module.exports = "<p>\n  signin works!\n</p>\n"